import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from './ui/Card';
import Button from './ui/Button';
import { useUser } from '../store/UserContext';

export default function PackDisabledPanel({ packName = 'This module', message = '', allowAdminLink = true }) {
  const navigate = useNavigate();
  const { user } = useUser();
  const isAdmin = user?.accessScope === 'admin';
  const description =
    message || `${packName} is currently unavailable for your account. Please contact your centre administrator.`;

  return (
    <div className="min-h-[50vh] flex items-center justify-center p-6">
      <Card className="p-6 max-w-lg w-full text-center space-y-3">
        <div className="sp-value" style={{ fontWeight: 600 }}>Module disabled</div>
        <div className="text-sm sp-muted">{description}</div>
        {isAdmin && allowAdminLink ? (
          <Button size="sm" onClick={() => navigate('/settings?tab=licensing')}>
            Manage licensing
          </Button>
        ) : (
          <div className="text-xs sp-muted">
            Access to this area is currently disabled. Please contact your centre administrator if you believe this is
            incorrect.
          </div>
        )}
      </Card>
    </div>
  );
}
